
import React from 'react';
import BaseComponent from './Base';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import DatePicker from 'react-datepicker2';

//کامپوننت اسناد علمی
class Requests extends BaseComponent {
    constructor(props) {
      let config = {
        subModuleName : "requests",
        filterParams: [
          {value:'',name:"m",type:"number",default:''},
          {value:'',name:"fd",type:"string",default:''},
          {value:'',name:"td",type:"string",default:''},
          {value:'',name:"i",type:"string",default:''},
        ]
      };

      super(props, config);
      this.state.action = (props.action === undefined || props.action === null ? "list" : props.action);
      this.state.on_edit=(Paper_id,params)=>{
        this.setState({id_to_edit:Paper_id});
      };
    }
    componentWillReceiveProps(props){
      
      this.setSearchValues("i","");
      this.setSearchValues("m","");
      this.setSearchValues("fd","");
      this.setSearchValues("td","");

      this.state.data = null;
      this.state.id_to_edit = null;
      this.state.list_url= '/api/organ/requests/';
      this.state.get_url= '/api/organ/requests/';

      this.state.action = (props.action === undefined || props.action === null ? "list" : props.action);
         
      super.componentWillReceiveProps(props);
    }
    getISIRecord(id){
      var record = {
        title: ''
      }
      this.state.data.isi_records.forEach(a=>{
        if (a.Paper_ID == id) record = a;
      })
      return record;
    }
    getDocRecord(id){
      var record = {
        title: ''
      };
      this.state.data.doc_records.forEach(a=>{
        if (a.id == id) record = a;
      })
      return record;
    }
    _modes(e=null){
      var list = [
        {value:"",label:"همه مدل های دسترسی"},
        {value:"2",label:"دسترسی شماره موبایل"},
        {value:"3",label:"دسترسی آی پی"},
        {value:"5",label:"دسترسی مستقیم اپراتور مرکز"},
        {value:"7",label:"دسترسی با ایمیل سازمانی"},
        {value:"8",label:"وب سرویس"}
      ];
      if (e === null)
        return list;
      else
      {
        var r = null;
        list.forEach(_t=>{
          if (_t.value == e)
            r = _t;
        });
        return r;
      }
    }
    getFilters()
    {
      return(
      <form onSubmit={e=>this.refresh(e)}>
        <div className="row topSearchBar">
          <div className="col-sm-3">
            <input type="text" placeholder="شماره درخواست" defaultValue={this.getFilterParamsValue("i")} className="form-control text-center" onChange={e => this.setSearchValues('i', e.target.value)} />
          </div>
          <div className="col-sm-3">
            <Select
              placeholder="همه مدل های دسترسی"                
              options={this._modes()}
              defaultValue={this._modes(this.getFilterParamsValue("m"))}
              onChange={e=>{
                this.setSearchValues('m',e.value);
                this.refresh();
              }}
            />
          </div>
          <div className="col-sm-2">
            <DatePicker
              inputReadOnly={true}
              className="form-control"
              placeholder={"از تاریخ"}
              isGregorian={false}
              showTodayButton={true}
              timePicker={false}
              onChange={e => {
                this.setSearchValues('fd', e );
                this.refresh();
              }}
              value={this.getListFilterDate(this.getFilterParamsValue("fd"))}
            />
          </div>
          <div className="col-sm-2">
            <DatePicker
              inputReadOnly={true}
              className="form-control"
              placeholder={"تا تاریخ"}
              isGregorian={false}
              showTodayButton={true}
              timePicker={false}
              onChange={e => {
                this.setSearchValues('td', e );
                this.refresh();
              }}
              value={this.getListFilterDate(this.getFilterParamsValue("td"))}
            />
          </div>
          <div className="col-sm-2 recordCount">
            <button className="hand" type="submit">
              <i className="fa fa-search"></i>
            </button> | 
            <span> {this.money(this.state.data.record_count)} مقاله</span>
          </div>
        </div>
      </form>
      );
    }
    renderListView(){
      return (
        <div>
          {this.getFilters()}
          {this.state.data.records.length > 0 ?
            <div className="row">
              {this.state.data.records.map(_t=>
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className={"box box-success"}>
                    <div className="box-body">
                      <ul className="products-list product-list-in-box">
                        <div className="item">
                          <p className="message">
                            {_t.RequestType === 7 ?
                              <p>عنوان مقاله: <a href={"/isi/id/" + _t.RqstdFileID} className="name">{this.getISIRecord(_t.RqstdFileID).Title}</a></p>
                            :
                              <p>عنوان مقاله: <a href={"/doc/" + _t.RqstdFileID} className="name" target="_blank">{this.getDocRecord(_t.RqstdFileID).title}</a></p>
                            }
                            <small>دریافت کننده: {
                              !this.isNull(_t.RealPerson) ?
                              _t.RealPerson.fname + ' ' + _t.RealPerson.lname + ' (' + _t.RealPerson.email + ')'
                              :
                              _t.UserEMail
                            }</small>
                            &nbsp;
                            <small>
                              آی پی: {_t.IP}
                            </small>
                            {_t.mode === 3 ? _t.download_count > 0 ? <span className="label label-success pull-left mr-r-5">دانلود شده</span> : <span className="label label-danger pull-left mr-r-5">دانلود نشده</span> : <span className="label label-success pull-left mr-r-5">دانلود شده</span>}
                            <span className="label label-primary pull-left mr-r-5">شماره درخواست: {_t.id}</span>
                            <span className="label label-info pull-left mr-r-5"><i className="fal fa-clock"></i> تاریخ درخواست: {this.g2j(_t.AddDate,0)}</span>
                            <span className="label label-warning pull-left">نحوه درخواست: {this.enumString(_t.mode,"mode")}</span>
                          </p>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>
          :
            <h4 className="alert alert-info text-center">موردی جهت نمایش یافت نشد</h4>
          }
          {this.createPaging()}
        </div> 
      );
    }
    render() {
      if (this.state.data === null || this.state.data === undefined) return this.showLoading();
      if (this.state.data.status === 2) return this.renderNoAccess();
      if (this.state.data.status === 404) return this.render404();
      if (this.state.data.status === 0 || this.state.data.status === 500) return this.render500();
      return this.renderListView()
    }
}
export default Requests;